export const ALERTSUCCESS='success';
export const ALERTERROR='error';
export const SUCCESSMESSAGE='Guardado con exito !, por favor espera...'
export const ERRORMESSAGE='Error al guardar, intentalo de nuevo.'
